import React from 'react';
import { Stack } from '@mui/material';
import { AccessTimeFilled, Check, Close, DoneAll } from '@mui/icons-material';
import { MatchScore, TCandidate } from './types';
import { theme } from '../../ThemeContext/ThemeObject';

interface MatchingCandidateComponentProps {
  candidate: TCandidate;
  condition: { id?: number; content: string; weight: number; short_label?: string };
}

const MatchingCandidateComponent: React.FC<MatchingCandidateComponentProps> = ({
  candidate,
  condition
}) => {
  if (!candidate) return null;

  const matchingCondition = candidate.matching_conditions.find((cond) => cond.id === condition.id);

  const matchingIndicator = () => {
    if (!matchingCondition) {
      return <AccessTimeFilled color="disabled" />;
    }

    switch (matchingCondition.matched_score) {
      case MatchScore.EXCELLENT:
        return <DoneAll sx={{ color: theme.palette.success.main }} />;
      case MatchScore.GOOD:
        return <Check sx={{ color: theme.palette.secondary.yellow }} />;
      default:
        return <Close sx={{ color: theme.palette.error.main }} />;
    }
  };

  return (
    <Stack direction="row" spacing={1}>
      <Stack>{matchingIndicator()}</Stack>
      <strong>{condition.content}</strong>
      <Stack>{matchingCondition?.suitability_comment}</Stack>
    </Stack>
  );
};

export default MatchingCandidateComponent;
